module.exports = __webpack_public_path__ + "img/6.182b0560.png";